import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07aa7889"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loby-item-root" }
const _hoisted_2 = {
  key: 0,
  class: "item-header-g1"
}
const _hoisted_3 = { class: "item-header-desk" }
const _hoisted_4 = { class: "item-header-ju-shoe" }
const _hoisted_5 = { class: "item-header-good-road" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-fill" }, null, -1))
const _hoisted_8 = { class: "road-map-summary" }
const _hoisted_9 = ["data-label"]
const _hoisted_10 = ["data-label"]
const _hoisted_11 = ["data-label"]
const _hoisted_12 = ["data-label"]
const _hoisted_13 = ["data-label"]
const _hoisted_14 = {
  key: 1,
  class: "item-header-g2"
}
const _hoisted_15 = { class: "item-header-g2-r1" }
const _hoisted_16 = { class: "item-header-desk" }
const _hoisted_17 = { class: "item-header-ju-shoe" }
const _hoisted_18 = { class: "item-header-good-road" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "item-header-g2-r2" }
const _hoisted_21 = { class: "road-map-summary" }
const _hoisted_22 = ["data-label"]
const _hoisted_23 = ["data-label"]
const _hoisted_24 = ["data-label"]
const _hoisted_25 = ["data-label"]
const _hoisted_26 = ["data-label"]
const _hoisted_27 = {
  key: 2,
  class: "item-body-g1"
}
const _hoisted_28 = {
  key: 0,
  class: "is-at-this-table"
}
const _hoisted_29 = {
  key: 3,
  class: "item-body-g2"
}
const _hoisted_30 = {
  key: 0,
  class: "is-at-this-table"
}
const _hoisted_31 = {
  key: 4,
  class: "is-reserved"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_road_map = _resolveComponent("road-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayType === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tableName), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["item-header-timer", _ctx.timerColor])
          }, _toDisplayString(_ctx.currentCount !== -1 ? _ctx.currentCount : ''), 3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.mData.downLimit + '-' + _ctx.mData.upLimit), 1),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.goodRoadName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.goodRoadName), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "road-map-summary-item red",
              "data-color": "red",
              "data-label": _ctx.mData.gameTypeNo.toUpperCase() === 'G002'
                    ? _ctx.t('roadmap.banker')
                    : _ctx.t('roadmap.dragon')
                    
            }, _toDisplayString(_ctx.redCount), 9, _hoisted_9),
            _createElementVNode("div", {
              class: "road-map-summary-item blue",
              "data-color": "blue",
              "data-label": _ctx.mData.gameTypeNo.toUpperCase() === 'G002'
                    ? _ctx.t('roadmap.player')
                    : _ctx.t('roadmap.tiger')
                    
            }, _toDisplayString(_ctx.blueCount), 9, _hoisted_10),
            _createElementVNode("div", {
              class: "road-map-summary-item green",
              "data-color": "green",
              "data-label": _ctx.t('roadmap.tie')
            }, _toDisplayString(_ctx.greenCount), 9, _hoisted_11),
            (_ctx.mData.gameTypeNo.toUpperCase() === 'G002')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "road-map-summary-item red pair",
                  "data-color": "red",
                  "data-label": _ctx.t('roadmap.pair')
                }, _toDisplayString(_ctx.redPairCount), 9, _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.mData.gameTypeNo.toUpperCase() === 'G002')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "road-map-summary-item blue pair",
                  "data-color": "blue",
                  "data-label": _ctx.t('roadmap.pair')
                }, _toDisplayString(_ctx.bluePairCount), 9, _hoisted_13))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.tableName) + " " + _toDisplayString(_ctx.mData.tableNo), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.mData.downLimit + '-' + _ctx.mData.upLimit), 1),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.goodRoadName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.goodRoadName), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "red",
                "data-label": _ctx.mData.gameTypeNo.toUpperCase() === 'G002'
                        ? _ctx.t('roadmap.banker')
                        : _ctx.t('roadmap.dragon')
                        
              }, _toDisplayString(_ctx.redCount), 9, _hoisted_22),
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "blue",
                "data-label": _ctx.mData.gameTypeNo.toUpperCase() === 'G002'
                        ? _ctx.t('roadmap.player')
                        : _ctx.t('roadmap.tiger')
                        
              }, _toDisplayString(_ctx.blueCount), 9, _hoisted_23),
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "green",
                "data-label": _ctx.t('roadmap.tie')
              }, _toDisplayString(_ctx.greenCount), 9, _hoisted_24),
              (_ctx.mData.gameTypeNo.toUpperCase() === 'G002')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "road-map-summary-item",
                    "data-color": "red",
                    "data-label": _ctx.t('roadmap.pair')
                  }, _toDisplayString(_ctx.redPairCount), 9, _hoisted_25))
                : _createCommentVNode("", true),
              (_ctx.mData.gameTypeNo.toUpperCase() === 'G002')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "road-map-summary-item",
                    "data-color": "blue",
                    "data-label": _ctx.t('roadmap.pair')
                  }, _toDisplayString(_ctx.bluePairCount), 9, _hoisted_26))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["item-header-timer", _ctx.timerColor])
            }, _toDisplayString(_ctx.currentCount !== -1 ? _ctx.currentCount : ''), 3)
          ])
        ])),
    (_ctx.displayType === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_road_map, {
            class: "road-map",
            mapData: _ctx.mData.expand.resultList,
            gameType: _ctx.mData.gameTypeNo.toUpperCase() === 'G002' ? 1 : 2,
            onRoadMapData: _ctx.onRoadMapDataParsed,
            beadRowCount: 10
          }, null, 8, ["mapData", "gameType", "onRoadMapData"]),
          (_ctx.isAtThisTable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.t('loby.atthistable')), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createVNode(_component_road_map, {
            class: "road-map",
            mapData: _ctx.mData.expand.resultList,
            gameType: _ctx.mData.gameTypeNo.toUpperCase() === 'G002' ? 1 : 2,
            onRoadMapData: _ctx.onRoadMapDataParsed,
            beadRowCount: 10,
            display: 2
          }, null, 8, ["mapData", "gameType", "onRoadMapData"]),
          (_ctx.isAtThisTable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.t('loby.atthistable')), 1))
            : _createCommentVNode("", true)
        ])),
    (_ctx.mData.reserverd > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31))
      : _createCommentVNode("", true)
  ]))
}